import { doc, getDoc } from "firebase/firestore";
import { db } from "../../../firebase";

const getSingleTemplate = async (templateId) => {
  try {
    const templateDocument = doc(db, "emailTemplates", templateId);
    const templateSnapshot = await getDoc(templateDocument);
    let templateData = {
      ...templateSnapshot.data(),
    };
    return templateData;
  } catch (error) {
    console.log(error);
  }
};

export default getSingleTemplate;
